import React from 'react'
const URLS = {
  de: {
    country: 'Deutschland',
    slug: '/impressum',
    basePath: '/',
    category: '',
    title: 'Impressum',
    isAvailableInCountry: false
  },
  at: {
    country: 'Österreich',
    slug: '/at/impressum',
    basePath: '/',
    category: '',
    title: 'Ösi Impressum',
    isAvailableInCountry: false
  }
}

const LanguageContext = React.createContext('de')

const useLanguage = () => {
  const [language, setLanguage] = React.useContext(LanguageContext)

  const handleLanguage = translations => {
    setLanguage(translations)
  }

  return { translations: language, onChange: handleLanguage }
}

const LanguageProvider = ({ value, children }) => {
  const [language, setLanguage] = React.useState(value.val || URLS)
  return (
    <LanguageContext.Provider value={[language, setLanguage]}>
      {children}
    </LanguageContext.Provider>
  )
}

export { LanguageProvider, useLanguage }
